/*
 *
 * File: dataObjects.js
 *
 * Purpose: Data objects declarations.
 *
 * Author:   Thomas Burgard (Software development)
 * Created:  21.03.2022
 * Modified: 25.04.2023 - Insert new passenger registration data object
 * Modified: 04.05.2023 - Insert new screenIdent -> passengerAcceptBookingsDetailsScreen
 * 
 * Copyright (c) DrivePartner GmbH 2022
 *
 */

//--------------------------------------------------------------
//--- User registration data object
//--------------------------------------------------------------
export const usrRegistrationDataObj = {
  userID:   null,
  username: null,
  userPswd: null,
  annahmefrist: null,
  companynameOrOwner: null,
  services: null,
  locations: null,
  tariff: null,
  showTariffRegulationText: null,
  agbLink: "",
  dataprotectionLink: "",
  impressumFirmenName: "",
  impressumFirmenStrasse: "",
  impressumFirmenPlz: "",
  impressumFirmenStadt: "",
  impressumFirmenLand: "",
  impressumFirmenUstId: "",
  impressumFirmenWebAdresse: "",
  impressumFirmenTelefon: "",
  impressumFirmenMail: "",
  impressumRegisterGericht: "",
  impressumHRB: "",
  impressumRechtsform: "",  
  impressumGF: "",
  premium: "",
  stripeConnectID: "",
}

//--------------------------------------------------------------
//--- User route fare calculation data object
//--------------------------------------------------------------
export const usrCalcRouteObj = {
  tariffsConfigured:          false,
  routePriceOptimization:     false,
  shortestRoute:              false, 
  fastestRoute:               false,
  routeWithDifferentTariffs:  false,
  roundUpRoutePrices:         false,
  roundOffRoutePrices:        false,
  roundNotRoutePrices:        false,  
  maxKmLongerAsShortestRoute: 0,
  calcDistance:               0,
  calcDuration:               0,
  calcFareLimBusiness:        0,    
  calcFareLimFirstClass:      0,
  calcFareBusinessVan:        0,
  calcFareBusXL:              0,
  carModelsLimBusiness:       { carModel1: "", carModel2: "", carModel3: "", carModel4: "" },
  carModelsLimFirstClass:     { carModel1: "", carModel2: "", carModel3: "", carModel4: "" },
  carModelsBusVan:            { carModel1: "", carModel2: "", carModel3: "", carModel4: "" },
  carModelsBusXL:             { carModel1: "", carModel2: "", carModel3: "", carModel4: "" },
  choosenCarOffer:            null,
};

//--------------------------------------------------------------
//--- User car category data object
//--------------------------------------------------------------
export const usrCarCategoryObj = {  
  startFare:     0,
  freeKm:        0,
  distArea2:     0,
  distArea3:     0,
  fareDistArea1: 0,
  fareDistArea2: 0,
  fareDistArea3: 0,
  hourFreeKm:    0,
  hourFare:      0,
  carCategory:   "",
  carModel1:     "",
  carModel2:     "",
  carModel3:     "",
  carModel4:     "",
};

//--------------------------------------------------------------
//--- Booking data values object
//--------------------------------------------------------------
export const bookingDataValuesObj = {
  pickupFrom: null,
  transferTo: null,
  waypoint1: null,
  waypoint2: null,
  waypoint3: null,
  pickupTime: null,
  pickupDate: null,
  payment: null,
  passengerName: null,
  mobilePhone: null,
  pax: null,
  airport: null,
  comment: null,
  bookedFrom: null,
  phone: null,
  email: null,
  calcRouteObj: usrCalcRouteObj,
  companyName: "",
  companyStreet: "",
  companyZip: "",
  companyLocation: "",
};

//--------------------------------------------------------------
//--- Passenger registration data values object
//--------------------------------------------------------------
export const registrationDataValuesObj = {
  actionCode: null,
  driverID: null,
  surname:  null,
  lastName: null,
  street:   null,
  zip:      null,
  location: null,
  phone:    null,
  username: null,
  password: null,
  email:    null,
};

///--------------------------------------------------------------
//--- Car category data object
//--------------------------------------------------------------
export const carCategory = {
  LimBusiness:   1,
  LimFirstClass: 2,
  BusinessVan:   3,
  BusXL:         4,
};

//--------------------------------------------------------------
//--- Screen identification number
//--------------------------------------------------------------
export const screenIdent = {
  bookingScreen: 1,
  helpScreen: 2,
  customerInfo: 3,
  dataProtection: 4,
  legalNotice: 5,
  termsOfUse: 6,
  fixPriceRoutesScreen: 7,
  changeBookingScreen: 8,
  passengerLoginScreen: 9,
  passengerRegisterScreen: 10,
  passengerStartScreen: 11,
  passengerAcceptBookingsScreen: 12,
  passengerAcceptBookingsDetailsScreen: 13,
  sharedLayout: 14,
  bookingTestScreen: 15,
};